


































import { Component, Vue, Watch } from 'vue-property-decorator';
import SignupComponent from '@/components/signup/signup.component.vue';
import { State } from 'vuex-class';
import { CognitoUser } from '@aws-amplify/auth';
const namespace = 'profile';

@Component({ components: { SignupComponent } })
export default class Signup extends Vue {
  @State('cognitoUser', { namespace }) public cognitoUser?: CognitoUser;

  mounted() {
    if (!this.cognitoUser) this.$router.push({ name: 'login' });
  }

  @Watch('cognitoUser')
  onUserChange(val?: CognitoUser) {
    if (!val) this.$router.push({ name: 'login' });
  }
}
